import '@coach/ui/tokens.css';
import { Capacitor } from '@capacitor/core';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { registerSW } from 'virtual:pwa-register';

// The website updates through its service worker. The native apps run only
// the code shipped in their build (App Store Guideline 2.5.2 — no downloaded
// code), so they never register it: on Android (https://localhost) it would
// also keep serving stale cached files after a store update.
if (!Capacitor.isNativePlatform()) registerSW({ immediate: true });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
